import { useCallback } from 'react';

import { GuideName } from '@app/api/guides';
import { useGuide } from '@app/hooks';

export const useFetchOptions = (source: GuideName | undefined, onOptionsFetch?: (options: any[]) => EntityBase[]) => {
  const fetch = useGuide(source);
  
  return useCallback(async () => {
    if (!source) {return onOptionsFetch?.([]) || [];}
    
    const options = await fetch();
    return onOptionsFetch ? onOptionsFetch(options) : options;
  }, [fetch, source, onOptionsFetch]);
};